import React from 'react';

export default {
  svg: (
    <g>
      <path
        fill="none"
        stroke="#222"
        strokeWidth={1.3}
        strokeMiterlimit={10}
        d="M15 14.36V11.5h18v21H15V20.86"
      />
      <defs>
        <path
          id="prefix__a"
          d="M29.75 15.29v1.94H18.53l-1.08-1.94h12.3zm0 2.97v1.94h-12.3l.91-1.94h11.39zm0 2.98v1.94h-12.3v-1.94h12.3z"
        />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <path clipPath="url(#prefix__b)" fill="#222" d="M12.45 10.29h22.3v17.9h-22.3z" />
      <path d="M13.43 17.5h3-3z" fill="none" stroke="#222" strokeMiterlimit={10} />
      <g>
        <defs>
          <circle id="prefix__c" cx={15} cy={17.5} r={4} />
        </defs>
        <clipPath id="prefix__d">
          <use xlinkHref="#prefix__c" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__d)">
          <defs>
            <path id="prefix__e" d="M-2-.01h34v35H-2z" />
          </defs>
          <clipPath id="prefix__f">
            <use xlinkHref="#prefix__e" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__f)">
            <defs>
              <path id="prefix__g" d="M11 12.99h8v9h-8z" />
            </defs>
            <clipPath id="prefix__h">
              <use xlinkHref="#prefix__g" overflow="visible" />
            </clipPath>
            <circle
              cx={15}
              cy={17.5}
              r={4}
              clipPath="url(#prefix__h)"
              fill="none"
              stroke="#222"
              strokeWidth={2.6}
              strokeMiterlimit={10}
            />
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '10 7 30 30'
};
